// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26rf7","buttons":"styles_buttons__3lqg0"};